import { IconButton } from '@material-ui/core';
import { ArrowForward, CheckRounded, Close } from '@material-ui/icons';
import { FC } from 'react';
import { useAuthStyles } from '../../Auth.styles';
import { useHelpModalConfirmationStyles } from './HelpModalConfirmation.styles';

interface HelpModalConfirmationProps {
  onClose: () => void;
  onTakeTest: () => void;
}

export const HelpModalConfirmation: FC<HelpModalConfirmationProps> = ({ onClose, onTakeTest }) => {
  const shared = useAuthStyles();
  const local = useHelpModalConfirmationStyles();
  const cls = { ...shared, ...local };

  return (
    <div className={cls.helpConfirmContainer}>
      <IconButton className={cls.helpConfirmCloseButton} onClick={onClose} aria-label="Fermer">
        <Close />
      </IconButton>
      <div className={cls.helpConfirmIconWrapper}>
        <CheckRounded className={cls.checkIcon} />
      </div>
      <div className={cls.helpConfirmTextGroup}>
        <h2 id="help-modal-title" className={cls.helpConfirmTitle}>
          Confirmation
        </h2>
        <p className={cls.helpConfirmDescription}>
          Votre demande a bien été envoyée. Notre équipe est à votre écoute et reviendra vers vous
          dans les meilleurs délais.
        </p>
      </div>
      <button type="button" className={cls.helpConfirmCta} onClick={onTakeTest}>
        <span>Faire un test</span>
        <ArrowForward className={cls.helpConfirmCtaIcon} />
      </button>
    </div>
  );
};
